import axios from 'axios';

// URL base de tu API
const API_BASE_URL = 'https://api.sindicato.pitayasoft.mx/api';

// Creamos una instancia de Axios para no repetir la URL base
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
  },
});

// --- CREDENCIALES ---
// Guardamos las credenciales en un solo lugar para fácil acceso
const credentials = {
  consult: {
    user: "Admin",
    password: "$dm1nSind!C4t."
  },
  create: {
    user: "AdminCrear",
    password: "$dm1nSind!C4t.R0=t"
  }
};

// --- FUNCIONES DE AUTENTICACIÓN ---

const tokenCache = {
  consult: { token: null, expiresAt: 0 },
  create: { token: null, expiresAt: 0 },
};

const TOKEN_TTL_MS = 50 * 60 * 1000;

/**
 * Obtiene un token de acceso según el tipo (consult o create)
 * @param {'consult' | 'create'} type - El tipo de credenciales a usar.
 * @returns {Promise<string>} El token de autenticación.
 */
const getAuthToken = async (type = 'consult') => {
  const cached = tokenCache[type];
  if (cached.token && Date.now() < cached.expiresAt) {
    return cached.token;
  }

  try {
    const response = await apiClient.post('/Login/acceso', credentials[type]);
    if (response.data && response.data.token) {
      tokenCache[type] = {
        token: response.data.token,
        expiresAt: Date.now() + TOKEN_TTL_MS,
      };
      return response.data.token;
    }
    throw new Error('No se recibió un token válido.');
  } catch (error) {
    tokenCache[type] = { token: null, expiresAt: 0 };
    throw new Error(`Error de autenticación (${type}).`);
  }
};


// --- FUNCIONES DE CONSULTA (usan token de consulta) ---

/**
 * Busca un usuario por RFC o CURP.
 * @param {string} rfcOrCurp - El RFC o CURP a buscar.
 * @param {string} token - El token de consulta.
 * @returns {Promise<object>} Los datos del usuario encontrado.
 */
export const searchUserByRfc = async (rfcOrCurp, token) => {
  const payload = { busqueda: rfcOrCurp.toUpperCase() };
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const response = await apiClient.post('/Usuarios/buscarRFC', payload, config);
  return response.data;
};

/**
 * Obtiene todos los catálogos necesarios para el formulario.
 * @param {string} token - El token de consulta.
 * @returns {Promise<object>} Un objeto con los catálogos.
 */
export const fetchCatalogs = async (token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  try {
    // Hacemos las 3 llamadas en paralelo para mayor eficiencia
    const [municipiosRes, regionesRes, nivelesRes] = await Promise.all([
      apiClient.get('/Catalogos/Municipios', config),
      apiClient.get('/Catalogos/RegionSindical', config),
      apiClient.get('/Catalogos/NivelEducativo', config)
    ]);

    return {
      municipios: municipiosRes.data,
      regiones: regionesRes.data,
      niveles: nivelesRes.data,
    };
  } catch (error) {
    throw new Error("No se pudieron cargar los datos para el formulario.");
  }
};


// --- FUNCIONES DE CREACIÓN (usan token de creación) ---

/**
 * Registra un nuevo usuario en el sistema.
 * @param {object} formData - Los datos del formulario del componente AddRecordForm.
 * @param {string} token - El token de creación.
 * @returns {Promise<object>} La respuesta de la API.
 */
export const createNewUser = async (formData, token) => {
  // 1. Mapear los datos usando los nombres CORRECTOS del estado 'formData'.
  const apiPayload = {
    // CORREGIDO: formData.nombre ya tiene el nombre completo.
    // También, la API parece esperar los nombres por separado, vamos a ajustar esto.
    nombre: formData.nombre,
    apellidoPaterno: formData.apellidoPaterno,
    apellidoMaterno: formData.apellidoMaterno,
    
    celular: formData.celular,
    rfc: formData.rfc,
    curp: formData.curp,
    
    // CORREGIDO: Usa los nombres de estado correctos.
    regionSeccional: formData.regionSeccional, 
    claveCct: formData.claveCct,
    nombreEscuela: formData.nombreEscuela,
    domicilioEscuela: formData.domicilioEscuela,
    correo: formData.correo.toLowerCase(),
    
    // CORREGIDO: Usa los nombres de ID correctos del estado.
    municipioId: Number(formData.idMunicipio),
    nivelId: Number(formData.idNivel),
    regionId: Number(formData.idRegion),
    
    // CORREGIDO: Usa los nombres de estado correctos.
    municipio_: formData.municipio_,
    nivel: formData.nivel,
    
    zonaEscolar: formData.zonaEscolar,
    fotografia: formData.fotografia,
    // CORREGIDO: Usamos el objeto Date nativo de JavaScript
    fechaCreacion: new Date().toISOString(),
    representanteEscuela: formData.representanteEscuela
  };
  
  // La API espera un array, aunque solo estemos enviando un usuario
  // const payloadAsArray = [apiPayload]; // <-- Elimina esta línea

  // 2. Realizar la llamada a la API enviando el objeto, no el array.
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const response = await apiClient.post('/Usuarios/altaUsuario', apiPayload, config); // <-- Envía apiPayload
  return response.data;
};

// Exportamos la función para obtener el token para poder usarla directamente en los componentes
export { getAuthToken };